module.exports = __webpack_public_path__ + "img/ChromeBrowser.c978f2a2.svg";